import * as React from "react";
import Content from "../../../Content";
import Axios from "../../Components/Axios";
import {Link} from "react-router-dom";

const backendUrl = process.env.REACT_APP_BACKEND ?? '';

class Edit extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            form: { },
            images: { },
            contentProviders: []
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        Axios
            .get('api/kp/list')
            .then(r => this.setState({ contentProviders: r.data }))
            .catch(() => this.props.history.push('/'));

        Axios
            .get('api/services/get/' + this.props.match.params.login)
            .then(r =>
                r?.success ? this.fill(r.data) : this.props.history.push('/admin/services_edit')
            )
            .catch(() => this.props.history.push('/'));
    }

    fill(data) {
        this.setState({
            form: {
                api_url: data?.apiUrl ?? '',
                title_ru: data?.titleRu,
                title_kg: data?.titleKg,
                kp_id: data.kpId,
                login: data.login,
                more_url_ru: data.moreUrlRu,
                more_url_kg: data.moreUrlKg,
                price_ru: data.priceRu,
                price_kg: data.priceKg,
                one_click: data.oneClick,
                sms_auth: data.smsAuth,
                token_salt: data.tokenSalt
            },
            images: {
                logo_ru: data.logoRu.split('.')[0],
                logo_kg: data.logoKg.split('.')[0],
                poster_ru: data.posterRu.split('.')[0],
                poster_kg: data.posterKg.split('.')[0]
            }
        });
    }

    handleSubmit(e) {
        e.preventDefault();

        let formData = new FormData();
        for(let i in this.state.form) {
            formData.append(i, this.state.form[i]);
        }

        Axios
            .post(
                'api/services/edit',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(r => (r?.success && this.props.history.push('/admin/services_edit')))
            .catch(() => this.props.history.push('/'));
    }

    handleChange(e, field, parent = null) {

        if(e.target.type === 'file') {
            if(!e.target.files.length || e.target.files[0].type.split('/')[0] !== 'image') {
                document.getElementById(field).src = "/images/ph.png";
                return;
            }

            let parentNode = this.state[parent];
            parentNode[field] = e.target.files[0];
            this.setState({
                [parent]: parentNode
            });

            let fr = new FileReader();
            fr.onload = () => document.getElementById(field).src = fr.result;
            fr.readAsDataURL(e.target.files[0]);
            return;
        }

        let isCheckbox = e.target.type === 'checkbox';

        if(parent === null) {
            this.setState({
                [field]: isCheckbox ? e.target.checked : e.target.value
            });
        }
        else
        {
            let parentNode = this.state[parent];
            parentNode[field] = isCheckbox ? e.target.checked : e.target.value;
            this.setState({
                [parent]: parentNode
            });
        }
    }

    isValidUrl(str = '') {
        if(!str.startsWith('http') && !str.startsWith('https'))
            return false;

        try {
            new URL(str);
        } catch (_) {
            return false;
        }
        return true
    }

    render() {

        let imgStyle = {
            height: '100px',
            width: 'auto'
        };

        return (
            <Content title = "Добавление Услуги">
                <div className="row mb-3">
                    <div className="col d-flex justify-content-between align-items-center">
                        <h5>Редактирование услуги</h5>
                    </div>
                </div>
                <div className="row my-3">
                    <div className="col-12">
                        <Link className="btn btn-light mr-4" to={'/admin/services_edit'}>← Назад</Link>
                    </div>
                </div>

                <form onSubmit={this.handleSubmit} encType="multipart/form-data">
                    <div className="row">
                        <div className="form-group col-4">
                            <label>Логин</label>
                            <input
                                disabled
                                value={this.state.form.login ?? ''}
                                type="text"
                                className="form-control"
                                placeholder="amediateka"
                                onChange={e => this.handleChange(e, 'login', 'form')}
                            />
                        </div>
                        <div className="form-group col-4">
                            <label>Название услуги на русском</label>
                            <input
                                value={this.state.form.title_ru ?? ''}
                                type="text"
                                className={ "form-control" + (this.state.form?.title_ru?.length ? '' : ' is-invalid') }
                                placeholder="МегаКниги"
                                onChange={e => this.handleChange(e, 'title_ru', 'form')}
                            />
                        </div>
                        <div className="form-group col-4">
                            <label>Название услуги на кыргызском</label>
                            <input
                                value={this.state.form.title_kg ?? ''}
                                type="text"
                                className={ "form-control" + (this.state.form?.title_kg?.length ? '' : ' is-invalid') }
                                placeholder="МегаКитептер"
                                onChange={e => this.handleChange(e, 'title_kg', 'form')}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-4 ">
                            <label>Контент-провайдер</label>
                            <select
                                className={ "form-control" + (!!this.state.form.kp_id ? '' : ' is-invalid') }
                                value={this.state.form.kp_id ?? 0}
                                onChange={e => this.handleChange(e, 'kp_id', 'form')}
                            >
                                {
                                    this.state.contentProviders.map(v=><option key={v.id} value={v.id}>{v.title}</option>)
                                }
                            </select>
                        </div>
                        <div className="form-group col-4 ">
                            <label>Стоимость на русском</label>
                            <input
                                value={this.state.form.price_ru ?? ''}
                                className={ "form-control" + (this.state.form?.price_ru?.length ? '' : ' is-invalid') }
                                type="text"
                                placeholder="10"
                                onChange={e => this.handleChange(e, 'price_ru', 'form')}
                            />
                        </div>
                        <div className="form-group col-4 ">
                            <label>Стоимость на кыргызском</label>
                            <input
                                value={this.state.form.price_kg ?? ''}
                                className={ "form-control" + (this.state.form?.price_kg?.length ? '' : ' is-invalid') }
                                type="text"
                                placeholder="10"
                                onChange={e => this.handleChange(e, 'price_kg', 'form')}
                            />
                        </div>
                        <div className="form-group col-12 pt-3">
                            <div className="pl-4 pt-3 pb-0">
                                <label className="form-check-label" >
                                    <input
                                        className="form-check-input "
                                        type="checkbox"
                                        checked={!!this.state.form.sms_auth}
                                        onChange={e => this.handleChange(e, 'sms_auth', 'form')}
                                    />
                                    Обязательное СМС подтверждение
                                </label>
                            </div>
                        </div>
                        <div className="form-group col-12 pt-3">
                            <div className="pl-4 pt-3 pb-0">
                                <label className="form-check-label">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={!!this.state.form.one_click}
                                        onChange={e => this.handleChange(e, 'one_click', 'form')}
                                    />
                                    Подключение в 1 клик.
                                </label>
                            </div>
                        </div>
                        <div className="form-group col-6 ">
                            <label htmlFor="exampleInputEmail1">Ссылка страницы услуги (RU)</label>
                            <input
                                name="more_url_ru"
                                className={ "form-control" + (this.isValidUrl(this.state.form?.more_url_ru) ? '' : ' is-invalid') }
                                type="text"
                                value={this.state.form.more_url_ru ?? ''}
                                placeholder="https://www.megacom.kg/options/instagram?locale=kg"
                                onChange={e => this.handleChange(e, 'more_url_ru', 'form')}
                            />
                        </div>
                        <div className="form-group col-6 ">
                            <label htmlFor="exampleInputEmail1">Ссылка страницы услуги (KG)</label>
                            <input
                                name="more_url_kg"
                                className={ "form-control" + (this.isValidUrl(this.state.form?.more_url_kg) ? '' : ' is-invalid') }
                                type="text"
                                value={this.state.form.more_url_kg ?? ''}
                                placeholder="https://www.megacom.kg/options/instagram?locale=kg"
                                onChange={e => this.handleChange(e, 'more_url_kg', 'form')}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-8 ">
                            <label htmlFor="exampleInputEmail1">API_URL</label>
                            <input
                                name="api_url"
                                className={ "form-control" + (this.isValidUrl(this.state.form?.api_url) ? '' : ' is-invalid') }
                                type="text"
                                placeholder="https://amediateka.megacom.kg/subscribe?"
                                onChange={e => this.handleChange(e, 'api_url', 'form')}
                                value={this.state.form.api_url ?? ''}
                            />
                        </div>
                        <div className="form-group col-4 ">
                            <label htmlFor="exampleInputEmail1">Соль для токена</label>
                            <input
                                name="token_salt"
                                className={ "form-control" + (this.state.form?.token_salt?.length ? '' : ' is-invalid') }
                                type="text"
                                placeholder="lkajsdfhjklasdfh"
                                onChange={e => this.handleChange(e, 'token_salt', 'form')}
                                value={this.state.form.token_salt ?? ''}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-6">
                            <label htmlFor="exampleInputEmail1">Логотип на русском</label>
                            <input
                                className="form-control image_view"
                                type="file"
                                style={{height: 'auto'}}
                                onChange={e => this.handleChange(e, 'logo_ru', 'form')}
                            />
                        </div>
                        <div className="form-group col-6">
                            <img src={`${backendUrl}api/uploads/${this.state?.images?.logo_ru ?? ''}`} id="logo_ru" className="viewer" style={imgStyle} alt = "" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-6">
                            <label htmlFor="exampleInputEmail1">Логотип на кыргызском</label>
                            <input
                                className="form-control image_view"
                                type="file"
                                style={{height: 'auto'}}
                                onChange={e => this.handleChange(e, 'logo_kg', 'form')}
                            />
                        </div>
                        <div className="form-group col-6">
                            <img src={`${backendUrl}api/uploads/${this.state?.images?.logo_kg ?? ''}`} id="logo_kg" className="viewer" style={imgStyle} alt = "" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-6">
                            <label htmlFor="exampleInputEmail1">Баннер на русском</label>
                            <input
                                className="form-control image_view"
                                type="file"
                                style={{height: 'auto'}}
                                onChange={e => this.handleChange(e, 'poster_ru', 'form')}
                            />
                        </div>
                        <div className="form-group col-6">
                            <img src={`${backendUrl}api/uploads/${this.state?.images?.poster_ru ?? ''}`} id="poster_ru" className="viewer" style={imgStyle} alt = "" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-6">
                            <label htmlFor="exampleInputEmail1">Баннер на кыргызском</label>
                            <input
                                className="form-control image_view"
                                type="file"
                                style={{height: 'auto'}}
                                onChange={e => this.handleChange(e, 'poster_kg', 'form')}
                            />
                        </div>
                        <div className="form-group col-6">
                            <img src={`${backendUrl}api/uploads/${this.state?.images?.poster_kg ?? ''}`} id="poster_kg" className="viewer" style={imgStyle} alt = "" />
                        </div>
                    </div>
                    <div className="form-group">
                        <button
                            type="submit"
                            className="btn btn-success"
                            disabled={
                                !this.state.form?.title_ru?.length ||
                                !this.state.form?.title_kg?.length ||
                                !this.state.form.kp_id ||
                                !this.state.form?.price_ru?.length ||
                                !this.state.form?.price_kg?.length ||
                                !this.isValidUrl(this.state.form?.more_url_ru) ||
                                !this.isValidUrl(this.state.form?.more_url_kg) ||
                                !this.isValidUrl(this.state.form?.api_url) ||
                                !this.state.form?.token_salt?.length
                            }
                        >
                            Сохранить
                        </button>
                        <Link
                            to={'/admin/services_edit'}
                            className="btn btn-danger ml-2"
                        >
                            Отмена
                        </Link>
                    </div>
                </form>
            </Content>
        );
    }
}

export default Edit;